import React from 'react';
import './index.scss';

//material-ui
import { CircularProgress, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, List, ListItem, Grid } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

//api
import {api} from '../../../functions/api';

//custom cpomponents
import Search from '../../../components/basic/search';

//other libraries
import { inject, observer } from 'mobx-react';
import uuid from 'uuid4';
import removeAccents from 'remove-accents';
import queryString from 'query-string'

const TIMEOUT = 3000;
const TIMEOUTUPDATE = 1000;

@inject('internal')
@inject('translate')
@observer
export default class ClientManager extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openSnackbar: false,
            message: "",
            permissions: {},
            menu: "",
            permission: "",
            enabled: null,
            searchTerm: "",
            foundPermissions: {},
            expanded: null
        }
    }

    _isMounted = false;

    componentDidMount() {
        this._isMounted = true;
        this.props.internal.setRoute( this.props.routerData.history, this.props.routerData.location.pathname)
        //this.loadPrivileges();
        
        this.loadAdminPrivileges();
    }

    timeout = null;
    timeoutupdate = null;
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.timeout)
        clearTimeout(this.timeoutupdate)
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout =  setTimeout(() => {
            this.setState({message: "", openSnackbar: false})
        }, TIMEOUT)
    }

    handleChangeExpanded  = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };

    loadAdminPrivileges = async () => {

        const URLqueryString = this.props.routerData.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {
            
            if(queries.searchterm) {
                this.setState({searchTerm: queries.searchterm})
            }
        }

        let load_data = await api({
            method: 'get',
            url: 'privileges/3',
            authorization: this.props.internal.user.access_token,
        })

        if(load_data.success === true) {
            
            //this.props.internal.setDataForSimpeTable(load_data.data.data.menu_permissions)
            for(let perm in load_data.data.data.menu_permissions) {
                load_data.data.data.menu_permissions[perm].sk_title = this.props.translate.i18n.MODULES.PRIVILEGES[perm.toString().toUpperCase()]
            }
            if (this._isMounted) {
                this.setState({permissions: load_data.data.data.menu_permissions})
            }

            if(queries && queries.searchterm) {
                this.handleSearch(queries.searchterm)
            }
        }
        if (this._isMounted) {
            this.setState({loading: false})
        }
    }

    renderExpansionPanel = () => {
        let permissions = this.state.permissions
        
        if(Object.keys(this.state.foundPermissions).length > 0 && this.state.foundPermissions.constructor === Object) {
            permissions = this.state.foundPermissions
        }
        
        let result = []
        const URLqueryString = this.props.routerData.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(Object.keys(this.state.foundPermissions).length === 0 && queries && queries.searchterm) {
            // result.push(<p className={'privileges-not-found'}>{this.props.translate.i18n.GLOBAL.ALERTS.NO_FOUND_DATA_FOR_TABE}</p>)
            result.push(<Grid key={uuid()} item sm={12} md={12} lg={12} style={{width: "100%"}}><p style={{textAlign:'center'}}>{this.props.translate.i18n.GLOBAL.ALERTS.NO_FOUND_DATA_FOR_TABE}</p></Grid>)
        }
        else {
            for(let key in permissions) {
                result.push(
                    <Grid key={uuid()}  item sm={12} md={6} lg={4} className={'grid-item'}>
                    <ExpansionPanel className={'expansion-panel'} expanded={this.state.expanded === key} onChange={this.handleChangeExpanded(key)}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <p >{this.props.translate.i18n.MODULES.PRIVILEGES[key.toUpperCase()]}</p>
                            {/* <p >{key.toUpperCase()}</p> */}
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={'expansion-detail'}>
                            <List dense className={'list-item'} >
                                {this.options(permissions[key], key)}
                            </List>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    </Grid>
                )
                
            }
        }
        return result
    }

    options = (options, modul) => {

        let result = []
        for(let key in options) {
            if(key !== "sk_title") {
                result.push(
                    <ListItem key={uuid()} value={options}  onClick={() => this.handleChange(modul, key)}>
                        {/* <p>{key.toString()}:{options[key].toString()}</p> */}
                        <input id={key.toString()} type="checkbox" value={key.toString()} defaultChecked={options[key]}/>
                        <label >{this.props.translate.i18n.MODULES.PRIVILEGES[key.toString().toUpperCase()]}</label>
                    </ListItem>
                )
            }
        }
        return result;
    }

    handleChange = (clickedModule, key) => {
        let permissions = this.state.permissions;
        let tmpModule = permissions[clickedModule]
        tmpModule[key] = !tmpModule[key]
        permissions[clickedModule] = tmpModule
        this.setState({permissions: permissions, menu: clickedModule, permission: key, enabled: tmpModule[key]}, () => {
            this.updatePrivilegesAdmin();
        })
        
    }

    updatePrivilegesAdmin = async () => {
        let update_data = await api({
            method: 'patch',
            url: 'privileges/3',
            authorization: this.props.internal.user.access_token,
            params: {
                menu: this.state.menu,
                permission: this.state.permission,
                enabled: this.state.enabled
            }
        })
        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            // this.loadAdminPrivileges();
            clearTimeout(this.timeoutupdate)
            this.timeoutupdate =  setTimeout(() => {
                this.loadAdminPrivileges();
            }, TIMEOUTUPDATE)
        }
    }


    handleSearch = (searchTerm) => {
        this.addQueryToUrl("searchterm", searchTerm)
        //searchTerm = this.translator(searchTerm);

        let perms = this.state.permissions
        let result = {}
        Object.keys(this.state.permissions).find(function(data){
            
            if(perms[data]['sk_title'].toLowerCase().includes(searchTerm.toLowerCase()) || removeAccents(perms[data]['sk_title'].toLowerCase()).includes(searchTerm.toLowerCase())) {
                result[data] = perms[data]
            }
            return false
            
        })
        this.setState({foundPermissions: result})
        
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        const URLqueryString = this.props.routerData.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.routerData.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
    }

    render() {
        let result = this.renderExpansionPanel()
        return (
            this.state.loading ?
                <CircularProgress className={'circular-progress'} />
                :
                <div  className={'admin-privileges'}>
                    <div className={'flex'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.PRIVILEGES.SEARCH} classes={'products-search-box'} onChange={this.handleSearch} value={this.state.searchTerm }/>
                    </div>
                    <Grid container spacing={16} className={'list-privileges'}>
                        
                        {result.map((perm, index) => {
                            return(
                                perm
                            );
                        })}
                    </Grid>
                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/privileges/client-manager/index.js